import React from "react";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";
import { BnbLabel } from "../../../utils/labels";
import * as Button from "../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import type { PriceType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useBnbSelector } from "../../../redux/store";
import Price from "../common/price/Price";
import * as Styles from "./styles/Summary";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { showPrice } from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";

type SummaryRowPropsType = {
    text: string;
    price?: PriceType;
    itemId?: string;
    onRemove?: () => void;
    popoverContent?: string | false;
};

const SummaryRow = (props: SummaryRowPropsType): JSX.Element => {
    const showPrices = useBnbSelector((state) => showPrice(state.commonSettings));

    return (
        <Styles.Row>
            <Flex.Row justifyContent="space-between" flexWrap="nowrap" data-testid="summary-row">
                <Flex.Col>
                    {props.text}
                    {props.popoverContent && <Popover showOnClick content={props.popoverContent} />}
                </Flex.Col>

                {(props.price || props.onRemove) && (
                    <Styles.PriceCol>
                        {props.price && (
                            <>
                                {props.price.discount === 0 && props.price.cash === 0 ? (
                                    showPrices && <BnbLabel label="standard" />
                                ) : (
                                    <Price price={props.price} financeItemId={props.itemId} />
                                )}
                            </>
                        )}
                        {props.onRemove && (
                            <Button.Link onClick={props.onRemove}>
                                <IconWrapper>
                                    <Icon variant="close" />
                                </IconWrapper>
                            </Button.Link>
                        )}
                    </Styles.PriceCol>
                )}
            </Flex.Row>
        </Styles.Row>
    );
};

export default SummaryRow;
